import React from 'react';
import "../../styles/MetricsRibbon.css"; 

export default function MetricsRibbon() {
  return (
    <section className="about-client-metrics-ribbon-bar">
      <div className="about-client-max-width metrics-ribbon-flex-row">
        
        {/* Left Laurel Crown Badge Title Node */}
        <div className="ribbon-celebrate-title-box">
          <span className="laurel-wreath-left">🌾</span>
          <span className="celebrate-script-text">Celebrating the Creator in You</span>
          <span className="laurel-wreath-right">🌾</span>
        </div>
        
        <div className="ribbon-vertical-divider" />
        
        
        <div className="ribbon-stat-node">
          <h3>50,000+</h3>
          <p>Happy Learners</p>
        </div>
        
        <div className="ribbon-vertical-divider" />
        
        
        <div className="ribbon-stat-node">
          <h3>100+</h3>
          <p>Expert Mentors</p>
        </div>
        
        <div className="ribbon-vertical-divider" />
        
        
        <div className="ribbon-stat-node">
          <h3>100+</h3>
          <p>Premium Courses</p>
        </div>
        
        <div className="ribbon-vertical-divider" />
        
        
        <div className="ribbon-stat-node">
          <h3>1M+</h3>
          <p>YouTube Subscribers <br className="mobile-break-hidden" /> (Combined)</p>
        </div>
        
        <div className="ribbon-vertical-divider" />
        
        
        <div className="ribbon-stat-node rating-flex-alignment">
          <div className="rating-star-wrapper">
            <span className="vector-gold-star">⭐</span>
            <h3 className="accent-white-text">4.9/5</h3>
          </div>
          <p>Average Rating</p>
        </div>

      </div>
    </section>
  );
}